"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.page.prev': 'Anterior',
    'dblogs.page.next': 'Siguiente',
    'dblogs.page.info': 'Página',
};
